export const EFFECTIVE = "October 18, 2026";
export const CONTACT = "info@voices2remember.com";

export const Mail = () => (
  <a className="font-semibold text-[#A83232] underline" href={`mailto:${CONTACT}`} data-testid="legal-contact-email">{CONTACT}</a>
);

export const Section = ({ title, children }) => (
  <section className="mt-10">
    <h2 className="font-serif text-2xl font-bold text-[#4A2A18]">{title}</h2>
    <div className="mt-3 space-y-3 text-lg leading-relaxed text-[#4A3B32] [&_li]:ml-6 [&_li]:list-disc [&_li]:pl-1">{children}</div>
  </section>
);

export const LegalPage = ({ title, testid, children }) => (
  <main className="mx-auto max-w-3xl px-5 py-14 sm:px-8" data-testid={testid}>
    <p className="font-script text-2xl text-[#A83232]">Voices 2 Remember</p>
    <h1 className="mt-1 font-serif text-4xl font-bold text-[#2C1E16] sm:text-5xl">{title}</h1>
    <p className="mt-3 text-base text-[#5C4A3E]">Effective {EFFECTIVE}</p>
    {children}
  </main>
);
